import { createSlice } from "@reduxjs/toolkit";

const recipeconfigrefreshSlice = createSlice({
  name: "recipeconfigrefresh",
  initialState: {
    refresh: false,
  },
  reducers: {
    setRefresh: (state, action) => {
      state.refresh = action.payload;
    },
    toggleRefresh: (state) => {
      state.refresh = !state.refresh;
    },
  },
});

export const { setRefresh, toggleRefresh } = recipeconfigrefreshSlice.actions;
export default recipeconfigrefreshSlice.reducer;
